import React from 'react';
import { RiDeleteBinLine } from 'react-icons/ri';
import './index.css';

const ChecksStep = ({
  checks,
  newCheck,
  setNewCheck,
  handleAddCheck,
  handleDeleteCheck,
  prevStep,
  nextStep
}) => {
  const checksTotal = checks.reduce((sum, check) => sum + check.amount, 0);

  return (
    <div className="sidePanel">
      <div className="checksPanel">
        <div className="panelHeader">
          <h3 style={{color:'white'}}>CHEQUES</h3>
          <div className="dateDisplay">
            {new Date().toLocaleDateString('es-ES', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </div>
        </div>
        <div className="checksTable">
          <table className="checksTableTable" style={{ width: "100%" }}>
            <thead>
              <tr className="tableHeader">
                <th>CHEQUE #</th>
                <th>FECHA</th>
                <th>BANCO</th>
                <th>GIRADOR</th>
                <th>A FAVOR DE</th>
                <th>MONTO</th>
                <th></th>
              </tr>
            </thead>
            <tbody className="checksScrollView">
              {checks.length === 0 && (
                <tr>
                  <td colSpan={7}>
                    <div className="emptyState">No hay cheques registrados</div>
                  </td>
                </tr>
              )}
              {checks.map((check, index) => (
                <tr key={`check-${index}`} className="checkRow">
                  <td className="checkNumber">{check.number}</td>
                  <td className="checkDate">{check.date}</td>
                  <td className="checkBank">{check.bank}</td>
                  <td className="checkDrawer">{check.drawer}</td>
                  <td className="checkBeneficiary">{check.beneficiary}</td>
                  <td className="checkAmount">
                    {check.amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                  </td>
                  <td>
                    <button
                      className="deleteButton"
                      onClick={() => handleDeleteCheck(index)}
                    >
                      <RiDeleteBinLine size={14} />
                    </button>
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan={7}>
                  <div className="newCheckForm" style={{ display: "flex", gap: 8 }}>
                    <input
                      type="text"
                      placeholder="#"
                      className="minimalInput"
                      value={newCheck.number}
                      onChange={e => setNewCheck({ ...newCheck, number: e.target.value })}
                    />
                    <input
                      type="date"
                      className="minimalInput"
                      value={newCheck.date}
                      onChange={e => setNewCheck({ ...newCheck, date: e.target.value })}
                    />
                    <input
                      type="text"
                      placeholder="Banco"
                      className="minimalInput"
                      value={newCheck.bank}
                      onChange={e => setNewCheck({ ...newCheck, bank: e.target.value })}
                    />
                    <input
                      type="text"
                      placeholder="Girador"
                      className="minimalInput"
                      value={newCheck.drawer}
                      onChange={e => setNewCheck({ ...newCheck, drawer: e.target.value })}
                    />
                    <input
                      type="text"
                      placeholder="A favor de"
                      className="minimalInput"
                      value={newCheck.beneficiary}
                      onChange={e => setNewCheck({ ...newCheck, beneficiary: e.target.value })}
                    />
                    <div className="amountInputGroup">
                      <input
                        type="number"
                        placeholder="Monto"
                        className="minimalInput"
                        value={newCheck.amount}
                        onChange={e => setNewCheck({ ...newCheck, amount: e.target.value })}
                        min="0"
                        step="any"
                      />
                      <button className="iconButton" onClick={handleAddCheck}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <line x1="12" y1="5" x2="12" y2="19"></line>
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={5} style={{ textAlign: "right", fontWeight: 600, color: "black" }}>TOTAL CHEQUES</td>
                <td colSpan={2} style={{ fontWeight: 600, color: "black" }}>
                  {checksTotal.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ChecksStep;

